
import { createApp } from 'vue'
import App from './App.vue'
import router from './route/route';
import { createPinia } from 'pinia'

/* 引入 ElementPlus */
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'

import store  from './store';
// 创建 Pinia 实例
const pinia = createPinia()
// 创建 Vue 实例
const app = createApp(App)
// 挂载到 Vue 根实例
app.use(createPinia())
app.use(store)
app.use(router)

app.use(ElementPlus)

app.mount('#app')







 

